// Dont change this import to from '../components', otherwise everything will break in tests!!!
import { AddressLocationType } from '../../../../../components/types/enums'
import { AddressType } from '../../../../../utils/classes/graphql'
import { BaseDetailsAddress } from '../types'
import { OwnInfoContactWrapper } from './own-info-contact-wrapper'

const newAddress: BaseDetailsAddress = {
  id: null,
  addressLocation: AddressLocationType.DOMESTIC,
  ensisijainen: false,
  katuosoite: '',
  maaKoodi: AddressLocationType.DOMESTIC,
  poisto: 0,
  postinumero: '',
  postitoimipaikka: '',
  tyyppi: AddressType.Kotiosoite
}

export const Addresses = () => (
  <OwnInfoContactWrapper
    name="yhteystiedot.osoitteet"
    keyPostfix="address"
    sectionTranslationId="addresses"
    newContactObject={newAddress}
    gridProps={{ md: 12 }}
  />
)
